import { call, put, select } from 'redux-saga/effects';
import { push } from 'redux-little-router';
import { confirmQSADataFailure, confirmQSASuccess } from '../redux/actions';
import { confirmQSA } from '../services/api';
import { getFormValues } from 'redux-form/immutable';
import { QUALIFIED_APPLICATION_FORM } from '../constants';

export function* confirmQSASaga({ payload: { step, cardId, pdfLink } }) {
  const formData = yield select(getFormValues(QUALIFIED_APPLICATION_FORM));
  const files = formData.get('files')
    ? formData.get('files').map((item) => item.serverFileName)
    : [];
  const { isOk, data, error } = yield call(confirmQSA, {
    cardId,
    pdf: pdfLink,
    attachedDocument: files,
  });
  if (isOk) {
    yield put(confirmQSASuccess(data));
    yield put(push({ query: { step } }, { persistQuery: true }));
  } else {
    yield put(confirmQSADataFailure(error));
  }
}
